import { render, staticRenderFns } from "./PageCulturalOrganization.vue?vue&type=template&id=cc35816c&"
import script from "./PageCulturalOrganization.vue?vue&type=script&lang=js&"
export * from "./PageCulturalOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc35816c')) {
      api.createRecord('cc35816c', component.options)
    } else {
      api.reload('cc35816c', component.options)
    }
    module.hot.accept("./PageCulturalOrganization.vue?vue&type=template&id=cc35816c&", function () {
      api.rerender('cc35816c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/culturalOrganization/PageCulturalOrganization.vue"
export default component.exports